import API from '../../../../services/API';

export default function searchKbk(prefix) {
  return API.request(
    {
      method: 'GET',
      url: `/dicts/kbk`,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      params: {
        prefix,
      },
    },
    true,
  ); //is cancelable
}
